import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {CalendarioComponent} from './calendario.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [CalendarioComponent],
  exports: [CalendarioComponent]
})
export class CalendarioModule {
}
